import { useState, useEffect } from "react";
import {
  chartGrid,
  chartInk,
  chartLabel,
  useThemeMode,
} from "../../contexts/theme-mode";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import "./bar1.style.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderRadius: 2,
};

export default function Bar1({ value, onClick }) {
  const { mode } = useThemeMode();
  const [data, setData] = useState({ datasets: [] });
  const [options, setOptions] = useState(defaultOptions);

  useEffect(() => {
    const labels = [];
    const total = [];
    const average = [];
    const transactions = [];

    (value || []).forEach((item) => {
      labels.push(item.Stylist || "");
      total.push(Number(item.total_spent) || 0);
      // Scale onto the total-spent axis so smaller series remain visible.
      average.push((Number(item.average_spent) || 0) * 10);
      transactions.push((Number(item.total_number) || 0) * 4);
    });

    setData({
      labels,
      datasets: [
        {
          label: "Total",
          data: total,
          backgroundColor: chartInk(mode),
        },
        {
          label: "Average",
          data: average,
          backgroundColor: "#cbaa6f",
        },
        {
          label: "Transactions",
          data: transactions,
          backgroundColor: "#8b4e3f",
        },
      ],
    });
  }, [value, mode]);

  useEffect(() => {
    const labelColor = chartLabel(mode);
    setOptions({
      ...defaultOptions,
      color: labelColor,
      plugins: {
        datalabels: {
          display: false,
        },
        title: {
          display: true,
          text: "Total Cost Per Transaction",
          position: "left",
          color: labelColor,
        },
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (ctx) {
              const datasetLabel = ctx.dataset.label;
              const raw = Number(ctx.parsed.y) || 0;

              if (datasetLabel === "Total") {
                return `${datasetLabel}: $${raw.toFixed(2)}`;
              }

              if (datasetLabel === "Average") {
                return `${datasetLabel}: $${(raw / 10).toFixed(2)}`;
              }

              if (datasetLabel === "Transactions") {
                return `${datasetLabel}: ${Math.round(raw / 4)}`;
              }

              return datasetLabel;
            },
          },
        },
      },
      scales: {
        y: {
          ticks: {
            stepSize: 50,
            color: labelColor,
          },
          grid: {
            color: chartGrid(mode),
          },
        },
        x: {
          ticks: {
            color: labelColor,
          },
          grid: {
            display: false,
          },
          offset: true,
        },
      },
    });
  }, [mode]);

  return (
    <div className="bar-body" onClick={onClick}>
      <h1 className="bar-title">Total Stylist Spending</h1>
      <div className="bar-container">
        <Bar data={data} options={options} onElementsClick={onClick} />
      </div>
    </div>
  );
}
